import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CampaignIcon(props: IconProps) {
    return <Icon {...props} iconKey={"campaign"}/>
}
